// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import {
  PlasmicSearchInput,
  DefaultSearchInputProps
} from "./plasmic/paziresh_24_search/PlasmicSearchInput";
import { HTMLElementRefOf } from "@plasmicapp/react-web";

// Your component props start with props for variants and slots you defined
// in Plasmic, but you can add more here, like event handlers that you can
// attach to named nodes in your component.
//
// If you don't want to expose certain variants or slots as a prop, you can use
// Omit to hide them:
//
// interface SearchInputProps extends Omit<DefaultSearchInputProps, "hideProps1"|"hideProp2"> {
//   // etc.
// }
//
// You can also stop extending from DefaultSearchInputProps altogether and have
// total control over the props for your component.
export interface SearchInputProps extends DefaultSearchInputProps {}

function SearchInput_(props: SearchInputProps, ref: HTMLElementRefOf<"div">) {
  // Use PlasmicSearchInput to render this component as it was
  // designed in Plasmic, by activating the appropriate variants,
  // attaching the appropriate event handlers, etc.  You
  // can also install whatever React hooks you need here to manage state or
  // fetch data.
  //
  // Props you can pass into PlasmicSearchInput are:
  // 1. Variants you want to activate,
  // 2. Contents for slots you want to fill,
  // 3. Overrides for any named node in the component to attach behavior and data,
  // 4. Props to set on the root node.
  //
  // By default, we are just piping all SearchInputProps here, but feel free
  // to do whatever works for you.

  // City names come from the API with a plain space («همه شهر ها»); show the
  // correct Persian form with a zero-width non-joiner («همه شهرها»).
  const cityName =
    typeof props.cityName === "string"
      ? props.cityName.replace(/ ها(?=\s|$)/g, "‌ها")
      : props.cityName;
  return <PlasmicSearchInput root={{ ref }} {...props} cityName={cityName} />;
}

const SearchInput = React.forwardRef(SearchInput_);
export default SearchInput;
